export default "__VITE_ASSET__40dfeae4__"